import { Link } from 'react-router-dom'
import { useLiveStatus } from './useLiveStatus'

export function LiveButton() {
  const live = useLiveStatus()
  if (!live) return null
  return <Link to="/live/" className="kr-live-button" aria-label="Сейчас в эфире — смотреть трансляцию"><span className="kr-live-button__dot" /> <span>СЕЙЧАС В ЭФИРЕ</span></Link>
}
